import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Select, {components} from "react-select";
import ReactSelectAdapter from "./ReactSelectAdapter";
import translate from "../../services/translation";
import SelectIcon from "../Favourites/SelectIcon";
import ResetButton from "./ResetButton";


export default class ParentDependentMultiSelect extends Component {

    static propTypes = {
        name: PropTypes.string,
        defaultOptionLabel: PropTypes.string,
        options: PropTypes.array,
        selectedOptions: PropTypes.array,
        selectedParents: PropTypes.array,
        selectedParent: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        onChange: PropTypes.func,
        disabled: PropTypes.bool,
        hasSpecialIcon: PropTypes.bool,
        resetFunction: PropTypes.func,
    };

    handleUpdateEvent = (updateEvent) => {
        const values = updateEvent !== null ? updateEvent.map(item => item.value) : [];

        const event = {
            target: {
                name: this.props.name,
                value: values
            }
        };

        this.props.onChange(event);
    };

    render() {
        const {name, defaultOptionLabel, options, selectedOptions, selectedParents, selectedParent, disabled, resetFunction} = this.props;

        const castOptions = options ? options.map(option => {
            return {value: option.uid, label: option.title, parents: option.parents || []};
        }) : [];

        const selectedOptionsArray = selectedOptions ? selectedOptions.map(selectedOption => castOptions.find(option => option.value === selectedOption)).filter(Boolean) : [];

        let availableOptions;

        if (selectedParent) {
            availableOptions = castOptions.filter(option => option.parents.includes(selectedParent));
        } else {
            availableOptions = castOptions.filter(option => {
                if (selectedParents) {
                    for (const filter of selectedParents) {
                        if (option.parents.includes(filter)) {
                            return true;
                        }
                    }
                }
                return false;
            })
        }

        const DropdownIndicator = props => {
            return (
                <components.DropdownIndicator {...props}>
                    {this.props.hasSpecialIcon?(<SelectIcon/>):null}
                </components.DropdownIndicator>
            );
        };

        return (
            <React.Fragment>
                {availableOptions.length > 0 &&
                    <div className={'selectCustom'}>
                        <Select
                            value={selectedOptionsArray}
                            onChange={this.handleUpdateEvent}
                            options={availableOptions}
                            isDisabled={disabled}
                            isMulti={true}
                            isClearable={false}
                            isSearchable={ false }
                            placeholder={defaultOptionLabel}
                            styles={ReactSelectAdapter.customStyles}
                            classNamePrefix={'select-basic'}
                            noOptionsMessage={() => translate('planner_list.no_options')}
                            components={{DropdownIndicator}}
                        />
                        {resetFunction && !disabled &&
                            <ResetButton reset={resetFunction} value={selectedOptionsArray.length} filterKey={name} />
                        }
                    </div>
                }
            </React.Fragment>
        );
    }
}

ParentDependentMultiSelect.defaultProps = {
    disabled: false,
};



// WEBPACK FOOTER //
// ./src/components/Planner/ParentDependentMultiSelect.js